export const sideNavbar = {
  home: "Home",
  games: "Games",
  allGames: "All",
  lottery: "Lottery",
  raffle: "Raffle",
  providers: "Providers",
  categories: "Category",
  casino: "Casino",
  casinos: "Casinos",
  sports: "Sports",
  allSports: "All",
  soccer: "Soccer",
  baseball: "Baseball",
  basketball: "Basketball",
  e_sports: "E-Sports",
  nfl: "NFL",
  allPageSports: "All",
  allPageGames: "All",
  support: "Support",
  live_casino: "Live Casino",
  bingo: "Bingo",
  horses: "Horses",
  hipism: "Hipism",
  News: "News",
  gameFeed: "Game Feed",
};
